/* global G */
import { curry, setKey } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import presetMessageField from 'app/_shared/action/partial/message/presetMessageField'

/**
 * Edit Message Event Handler
 *
 * Sets the message field into edit mode
 *
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the component that fired the event
 * @param {Gaia.PlatformEvent} event      the event; its `detail` is the message to edit
 * @returns {Promise<void>}
 */
const edit = async (module, component, event) => {
  event.preventDefault()
  event.stopPropagation()

  const { detail: message = {} } = event

  setKey(message, 'currentMessage', module[G.STATE])
  setKey(message?.value?.text || '', 'text', module[G.STATE])

  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  await presetMessageField(module)(find(actionComponent))

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(edit)
